// extracted by mini-css-extract-plugin
export default {"root":"UserHistoryDrawerQuery-root-99e1fe014bfea35f5d568dd70086da5a"};